import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=586d77a7&"
import script from "./UserMain.vue?vue&type=script&lang=ts&"
export * from "./UserMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports